import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PaymentPolicy/index.tsx");
